export default "__VITE_ASSET__BixXZBtn__"